export const PASSWORD_VERIFICATION_CHECK = 'PASSWORD_VERIFICATION_CHECK'
export const PASSWORD_VERIFICATION_CHECK_SUCCESS = 'PASSWORD_VERIFICATION_CHECK_SUCCESS'
export const PASSWORD_VERIFICATION_CHECK_FAILURE = 'PASSWORD_VERIFICATION_CHECK_FAILURE'

export const PASSWORD_VERIFICATION_CHECK_LOGIN = 'PASSWORD_VERIFICATION_CHECK_LOGIN'
export const PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS = 'PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS'
export const PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE = 'PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE'
